<template>
  <div class="comp-ly-skeleton-operation">
    <template v-if="fromType === 'operationInfo'">
      <div class="skeleton-inner-contain">
        <jw-skeleton :animation="true">
          <jw-space direction="vertical" :style="{ width: '100%' }">
            <jw-skeleton-line />
            <div class="skeleton-inner">
              <jw-skeleton-line :rows="2" :widths="[100, 100]" :lineHeight="20" :lineSpacing="8" />
            </div>
          </jw-space>
        </jw-skeleton>
      </div>
    </template>
    <template v-else>
      <div v-for="(i, index) in 2" :key="index" class="skeleton-contain">
        <jw-skeleton :animation="true">
          <jw-space direction="vertical" :style="{ width: '100%' }">
            <div class="title-skeleton">
              <jw-skeleton-line :widths="[120]" :lineHeight="18" />
              <jw-skeleton-line :widths="[30]" :lineHeight="18" />
            </div>
            <div class="person-skeleton">
              <jw-skeleton-line :widths="[80]" :lineHeight="26" />
            </div>
            <jw-skeleton-line />
            <div class="bottom-skeleton">
              <jw-skeleton-line :widths="[100]" :lineHeight="20" />
              <jw-skeleton-line :widths="[100]" :lineHeight="20" />
            </div>
          </jw-space>
        </jw-skeleton>
      </div>
    </template>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
console.log('1-开始创建组件-setup');
const data = reactive({});
const name = ref();
const props = defineProps({
  fromType: {
    type: String
  }
});
console.log('骨架瓶接收参数', props);
console.log(data, name, props);
</script>
<style scoped lang="less">
@import './ly-skeleton-operation.less';
</style>
